import React from 'react'
import { Button, Card, Layout, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Title, Paragraph, Text } = Typography

/** رقم واتساب الدعم (قناة بديلة عند تعذّر استخدام التطبيق) */
const WHATSAPP_E164 = '970595566789'
const WHATSAPP_DELETE_TEXT = encodeURIComponent(
    'مرحباً، أطلب حذف حسابي وبياناتي المرتبطة في لين غو. رقم هاتفي المسجّل في التطبيق: ',
)

/**
 * صفحة حذف الحساب — تتوافق مع متطلبات متاجر التطبيقات (حذف من داخل التطبيق + شفافية على الويب).
 */
export default function AccountDeletion() {
    const waUrl = `https://wa.me/${WHATSAPP_E164}?text=${WHATSAPP_DELETE_TEXT}`

    return (
        <Layout style={{ minHeight: '100vh', background: '#f4ede3' }}>
            <Layout.Content style={{ padding: 'clamp(16px, 4vw, 32px)', maxWidth: 840, margin: '0 auto', width: '100%' }}>
                <div dir="rtl" lang="ar" style={{ textAlign: 'right' }}>
                    <div style={{ marginBottom: 20 }}>
                        <Link to="/">
                            <Button type="link" style={{ paddingInline: 0 }}>← العودة إلى الرئيسية</Button>
                        </Link>
                        {' · '}
                        <Link to="/privacy">
                            <Button type="link" style={{ paddingInline: 0 }}>سياسة الخصوصية</Button>
                        </Link>
                    </div>

                    <Card styles={{ body: { padding: 'clamp(20px, 4vw, 32px)' } }}>
                        <Title level={2} style={{ marginTop: 0 }}>حذف الحساب والبيانات — لين غو</Title>
                        <Text type="secondary">LeenGo · تطبيق لين غو</Text>
                        <Paragraph style={{ marginTop: 8 }}>
                            يمكنك <Text strong>حذف حسابك بنفسك من داخل التطبيق</Text> دون انتظار موافقة يدوية.
                            هذه الصفحة توضّح الخطوات وتكمّل <Link to="/privacy">سياسة الخصوصية</Link>.
                        </Paragraph>

                        <Title level={4}>١. الحذف من تطبيق LeenGo (الطريقة الموصى بها)</Title>
                        <Paragraph>نفّذ التالي على هاتفك:</Paragraph>
                        <ol style={{ paddingInlineStart: 20, marginTop: 0 }}>
                            <li>افتح تطبيق <Text strong>LeenGo</Text> وسجّل الدخول بحسابك.</li>
                            <li>من القائمة الجانبية اختر <Text strong>الملف الشخصي</Text>.</li>
                            <li>مرّر للأسفل واضغط <Text strong>«حذف الحساب نهائياً»</Text>.</li>
                            <li>اقرأ التحذير، ثم أكّد في <Text strong>نافذتين متتابعتين</Text> حتى يكتمل الحذف.</li>
                        </ol>
                        <Paragraph>
                            بعد النجاح يُحذف الحساب من الخادم وتُغلق جلستك على الجهاز. قد يُعاد تسجيل الجهاز
                            لإشعارات «الزائر» إذا كانت لديك منطقة توصيل محفوظة محلياً.
                        </Paragraph>

                        <Title level={4}>٢. ماذا يُحذف أو يتغيّر؟</Title>
                        <ul style={{ paddingInlineStart: 20, marginTop: 0 }}>
                            <li>حذف <Text strong>سجل المستخدم</Text> المرتبط بالحساب (مثل رقم الهاتف والاسم في الحساب).</li>
                            <li>إزالة <Text strong>تسجيلات إشعار الجهاز</Text> المرتبطة بحسابك على الخادم.</li>
                            <li>
                                قد تبقى <Text strong>سجلات الطلبات السابقة</Text> لالتزامات تشغيلية وقانونية، مع{' '}
                                <Text strong>فك ارتباطها بحسابك المحذوف</Text> (لا يعود الطلب مرتبطاً بحساباً نشطاً).
                            </li>
                        </ul>

                        <Title level={4}>٣. إن تعذّر عليك استخدام التطبيق</Title>
                        <Paragraph>
                            إذا لم تستطع تسجيل الدخول أو فقدت الجهاز، يمكنك مراسلتنا عبر واتساب من{' '}
                            <Text strong>نفس رقم الهاتف</Text> المسجّل سابقاً لطلب المساعدة في التحقق والحذف.
                        </Paragraph>
                        <Paragraph>
                            <Button type="primary" size="large" href={waUrl} target="_blank" rel="noopener noreferrer">
                                فتح واتساب (طلب دعم / حذف)
                            </Button>
                        </Paragraph>
                        <Paragraph type="secondary" style={{ fontSize: 13 }}>
                            يمكنك أيضاً التواصل عبر «تواصل معنا» أو أي قناة دعم تظهر في الموقع أو التطبيق، مع ذكر
                            رقم الهاتف المسجّل وطلب حذف الحساب.
                        </Paragraph>

                        <Title level={4}>٤. المدة عند طلب الدعم</Title>
                        <Paragraph>
                            عندما يكون الحذف عبر الدعم (وليس من داخل التطبيق)، نعالج الطلب خلال{' '}
                            <Text strong>حوالي ٣٠ يوماً</Text> حيثما ينطبق ذلك بعد التحقق من هوية صاحب الحساب، ما لم تفرض
                            قوانين أو ظروف تقنية مدة أطول.
                        </Paragraph>

                        <Paragraph style={{ marginTop: 24 }}>
                            <Link to="/privacy">الاطلاع على سياسة الخصوصية الكاملة</Link>
                        </Paragraph>
                    </Card>
                </div>
            </Layout.Content>
        </Layout>
    )
}
